<!-- 全局列表组件 -->
<!-- 例子：	<body-list ref="bodyList" :placeholder="'搜索'"  :current="current" :pageMethod="'getReviewMeeting'">
			<template v-slot:default="slotProps">
				内容
			</template>
			<template v-slot:footer="slotProps">
				<button class="finish-btn" style="width: 200rpx;" @click="handleBack">返回</button>
				<button type="primary" class="finish-btn" style="width: 200rpx;"@click="handleAdd('confirm')">新建评审会</button>
			</template>
		</body-list> -->
<template>
	<view class="layout">
		<headSearch :isFix="isFix" :isSearch="isSearch" :isScanPop="isScanPop" :placeholder="placeholder" :current="current" :searchValue="searchValue" @search="search" @scanCode="scanCode" :tabs="tabs" :activeIndex="activeIndex" @changeTab="changeTab" :type="type" />
		<!-- 列表 -->
		<view class="order-list">
			<u-empty v-if="isNullData" mode="data" icon="http://cdn.uviewui.com/uview/empty/car.png" style="padding-top: 200rpx;"></u-empty>
			<!-- 列表内容插槽 -->
			<view v-for="(item,index) in list" :key="index">
				<slot name="main" :row="item"></slot>
			</view>
			<u-loadmore :status="loadStatus" v-if="!isNullData" />
		</view>

		<!-- 按钮 -->
		<view class="handle-btn" v-if="isFooter">
			<slot name="footer"></slot>
		</view>
		<!-- pda扫描 -->
		<scan></scan>
	</view>
</template>

<script>
	import scan from "@/components/scan/scan.vue"; //pda扫描
	//#ifdef APP-PLUS
		let mpaasScanModule = uni.requireNativePlugin("Mpaas-Scan-Module")
	//#endif

	export default {
		name: "body-list",
		props: {
			//搜索框文本
			placeholder: {
				type: String,
				default: '请输入生产单号或款号'
			},
			// tab状态数据
			tabs: {
				type: Array,
				default: []
			},
			// 按钮类型
			type: {
				type: String,
				default: ''
			},
			//默认索引
			current: {
				type: String | Number,
				default: 0
			},

			// 是否固定搜索头
			isFix: {
				type: Boolean,
				default: true
			},
			//是否显示搜索头
			isSearch: {
				type: Boolean,
				default: true
			},
			//数据接口
			pageMethod: {
				type: String,
				default: ''
			},
			// 是否展示扫码
			isScanPop: {
				type: Boolean,
				default: true
			},
			// 显示底部
			isFooter:{
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				//搜索框的值
				searchValue: '',
				//当前选中索引
				activeIndex: this.current || '0',
				//列表数据
				list: [], 
				//分页数
				pageNum: 1,
				//数据条数
				pageSize: 10,
				//当前是否是列表最后一页数据
				isLastPage: false,
				//加载图标状态
				loadStatus: 'loading', //当前的数据状态，loading加载中，
				//列表是否未空数据
				isNullData: false, //当前是否未空数据
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			// 初始化
			init() {
				this.reqListData()
			},
			refresh(){
				this.list = []
				this.pageNum = 1
				this.isLastPage = false
				this.init()
			},
			// 刷新列表数据
			onRefresh() {
				this.searchValue = ''
				this.list = []
				this.pageNum = 1
				this.isLastPage = false
				this.init()
				setTimeout(() => {
					uni.stopPullDownRefresh();
				}, 1000)
			},
			// 上拉加载
			oPullUpLoad() {
				// 如果是最后一页,无需加载数据
				if (!this.isLastPage) {
					this.pageNum += 1
					this.reqListData()
				}
			},
			// 请求列表数据
			reqListData(search) {
				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					search: search || '',
					status: this.tabs.length > 0 ? this.activeIndex : ''
				}
				this.$api[this.pageMethod](params, data => {
					if (data && data.success) {
						this.list = this.list.concat(data.data.list)
						this.isLastPage = data.data.isLastPage
						if (this.isLastPage) {
							this.loadStatus = 'nomore';
						}
						this.isNullData = false
					} else {
						this.isNullData = true
					}
				})
			},
			// 搜索
			search(e) {
				this.list = []
				this.pageNum = 1
				this.reqListData(e)
			},
			// 切换tab触发
			changeTab(e, status) {
				this.list = []
				this.activeIndex = e
				this.reqListData()
			}
		}
	}
</script>


<style lang='scss' scoped scoped>
	.layout {
		width: 100vw;

		.order-list {
			position: relative;
			z-index: 0;
			width: 100vw;
			padding: 20rpx 20rpx 20rpx;
			box-sizing: border-box;
			overflow: hidden;

			.sin-order {
				display: flex;
				align-items: center;
				border-radius: 10rpx;
				padding: 20rpx;
				margin-bottom: 30rpx;
				box-sizing: border-box;
				line-height: 1.8;
				border: 1px solid #eee;

				.order-img {
					width: 80rpx;
					height: 80rpx;
					margin-right: 20rpx;
					border-radius: 10rpx;
					overflow: hidden;

					image {
						width: 80rpx;
						height: 80rpx;
					}
				}

				.order-box {
					flex: 1;

					.order-title {
						flex: 1;
						width: 100%;
						display: flex;
						justify-content: space-between;

						.order-name {
							background-color: #3671FD;
							color: #fff;
							padding: 0 10rpx;
							margin-right: 10rpx;
							border-radius: 10rpx;
						}

						.order-state {
							color: #3671FD;
						}
					}

					.order-data {
						font-size: 26rpx;
						width: 100%;
						display: flex;
						justify-content: space-between;
					}
				}

				.order-btn {
					width: 30%;
					margin-right: 0;
					font-size: 24rpx;
					margin-left: 30rpx;
				}



				.order-content {
					font-size: 26rpx;
				}


			}
		}

		.details-popbox {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 999;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0, 0, 0, 0.1);

			.pop-box {
				position: absolute;
				top: 30vh;
				left: 5vw;
				background-color: #fff;
				border-radius: 20rpx;
				width: 90vw;
				padding: 40rpx 50rpx 80rpx;
				box-sizing: border-box;

				.pop-close {
					width: 100%;
					text-align: right;

					.pop-close-icon {
						font-size: 60rpx;
						color: #C0C0C0;
					}
				}

				.pop-details {
					width: 100%;
					height: 100%;
					overflow: scroll;

					.pop-sin-order {
						border-radius: 10rpx;
						padding: 20rpx;
						box-sizing: border-box;
						margin-bottom: 20rpx;
						display: flex;
						align-items: center;

						.pop-order-img {
							width: 80rpx;
							height: 80rpx;
							margin-right: 20rpx;
							border-radius: 10rpx;
							overflow: hidden;

							image {
								width: 80rpx;
								height: 80rpx;
							}

						}

						.pop-order-box {
							flex: 1;

							.pop-order-title {
								flex: 1;
								width: 100%;
								display: flex;
								justify-content: space-between;

								.pop-order-name {
									background-color: #3671FD;
									color: #fff;
									padding: 0 10rpx;
									margin-right: 10rpx;
									border-radius: 10rpx;
								}

								.pop-order-state {
									color: #3671FD;
								}
							}
						}



						.order-content {
							font-size: 26rpx;
						}

						.order-data {
							font-size: 26rpx;
							width: 100%;
							display: flex;
							justify-content: space-between;
						}
					}

					.print-btn {
						margin-top: 20rpx;
						width: 100%;
						height: 60rpx;
						line-height: 60rpx;
						text-align: center;
						border-radius: 10rpx;
						text-align: center;
						color: #fff;
						background-color: #3671FD;
					}

					.order-title {
						width: 100%;
						display: flex;
						justify-content: space-between;

						.order-num {
							margin: 0;
						}

						.order-name {
							background-color: #3671FD;
							color: #fff;
							padding: 0 10rpx;
							margin-right: 10rpx;
							border-radius: 10rpx;
						}

						.order-state {
							color: #3671FD;
						}
					}

					.details-btn {
						display: flex;
						flex-wrap: wrap;

						.saobtn {
							margin-top: 20rpx;
							margin-left: 10px;
							width: 40%;
							height: 70rpx;
							line-height: 70rpx;
							font-size: 28rpx;
						}
					}
				}
			}
		}

		.handle-btn {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100vw;
			height: 120rpx;
			display: flex;
			justify-content: space-around;
			align-items: center;
			background-color: #f5f5f5;
			margin-top: 30rpx;

			.finish-btn {
				font-size: 26rpx;
			}
		}
	}
</style>